import { createForm } from '../../../factories'

export default createForm(['name', 'email', 'password'])



// WEBPACK FOOTER //
// ./src/store/modules/client/forms/profile.js